module.exports = __webpack_public_path__ + "static/media/phone1.7df90878.svg";